import { createSlice } from "redux-starter-kit";


const appHeaderCart = createSlice({
    slice: "appHeaderCart",
    initialState: { basketCount: 0 },
    reducers: {
        incrementBasketCount(state) {
            state.basketCount++;
        },
    },
});

const { actions, reducer } = appHeaderCart;
export const { incrementBasketCount } = actions;
export default reducer;
